import { render, staticRenderFns } from "./BorderBox14.vue?vue&type=template&id=cb3ef876&scoped=true"
import script from "./BorderBox14.vue?vue&type=script&lang=js"
export * from "./BorderBox14.vue?vue&type=script&lang=js"
import style0 from "./BorderBox14.vue?vue&type=style&index=0&id=cb3ef876&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3ef876",
  null
  
)

export default component.exports